module.exports = __webpack_public_path__ + "static/img/inform-bg.67f6ccb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/inform-bg.png
// module id = JXbE
// module chunks = 3